import { SxProps, Theme } from '@mui/material';

export const styles: Record<string, SxProps<Theme>> = {
  overlay: {
    alignItems: 'center',
    backgroundColor: '#f4f7fb',
    color: '#152238',
    display: 'flex',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: 3,
  },

  card: {
    backgroundColor: '#ffffff',
    borderRadius: 2,
    boxShadow: '0 20px 45px rgba(21, 34, 56, 0.12)',
    maxWidth: 560,
    padding: 4,
    width: '100%',
  },

  errorText: {
    color: '#4f5d75',
    lineHeight: 1.6,
    marginBottom: 1.5,
  },

  eventId: {
    color: '#6b7280',
    fontFamily: 'monospace',
    marginBottom: 2.5,
  },

  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 1.5,
  },
};
